<style scoped lang="scss" type="text/scss">
    .user-container {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #EEE;
        overflow: hidden;

        .except-for-navbar {
            width: 100%;
            flex: 1;
            display: flex;
            justify-content: space-between;
            overflow: hidden;

            .except-for-sidebar {
                flex: 1;
                height: 100%;
                overflow: auto;
                display: flex;
                justify-content: center;
                box-sizing: border-box;
                padding: 1rem 1rem 0;

                .content-wrap {
                    width: 100%;
                    max-width: 1460px;
                    position: relative;
                    box-sizing: border-box;

                    .placeholder {
                        height: 1rem;
                    }
                }
            }
        }
    }
</style>

<template>
    <div class="user-container">
        <the-navbar :config="navbarConfig"></the-navbar>
        <section class="except-for-navbar">
            <the-sidebar :config="sidebarConfig"></the-sidebar>
            <section class="except-for-sidebar">
                <section class="content-wrap">
                    <router-view></router-view>
                    <section class="placeholder"></section>
                </section>
            </section>
        </section>
        <terms-dialog></terms-dialog>
    </div>
</template>

<script>
    import TheNavbar from '../../layout/navbar';
    import navbarConfig from '../../layout/navbar/user';
    import TheSidebar from '../../layout/sidebar';
    import sidebarConfigTemplate from '../../layout/sidebar/user';
    import TermsDialog from './terms';

    export default {
        name: '',
        components: {
            TheNavbar,
            TheSidebar,
            TermsDialog
        },
        data () {
            return {
                navbarConfig
            };
        },
        created () {
            this.$store.dispatch('user/loadUnreadInternalMessagesNumber').then();

            this.$store.dispatch('school/loadManagedSchools').then();
            this.$store.dispatch('team/loadManagedTeams').then();
            this.$store.dispatch('player/loadRegistrableManagedPlayers').then();
            this.$store.dispatch('player/loadMiddleableManagedPlayers').then();
        },
        beforeDestroy () {
            this.$store.commit('school/updateManagedSchools', []);
            this.$store.commit('team/updateManagedTeams', []);
            this.$store.commit('player/updateManagedPlayers', []);
            this.$store.commit('player/updateMiddlePlayers', []);
        },
        computed: {
            notice () {
                return this.$store.getters['user/notice'];
            },
            managedSchools () {
                return this.$store.state.school.managedSchools;
            },
            managedTeams () {
                return this.$store.state.team.managedTeams;
            },
            managedPlayers () {
                return this.$store.state.player.managedPlayers;
            },
            currentMiddlePlayers () {
                return this.$store.state.player.currentMiddlePlayers;
            },
            schoolManagePermission () {
                return this.managedSchools.length > 0;
            },
            teamManagePermission () {
                return this.managedTeams.length > 0;
            },
            playerManagePermission () {
                return this.managedPlayers.length > 0;
            },
            playerMiddlePermission () {
                return this.currentMiddlePlayers.length > 0;
            },
            sidebarConfig () {
                return sidebarConfigTemplate(this.schoolManagePermission, this.teamManagePermission, this.playerManagePermission, this.playerMiddlePermission, this.notice);
            }
        }
    };
</script>
